import { Image } from '@graphcommerce/image'
import { useEffect, useRef, useState } from 'react'

type ResponsiveImageGridItemProps = {
  src: string
  alt?: string
  aspect?: string
  className?: string
  rounded?: boolean
  hasHoverEffect?: boolean
  borderRadius?: string
}

export function ResponsiveImageGridItem(props: ResponsiveImageGridItemProps) {
  const {
    src,
    alt,
    aspect = '4/3',
    className,
    rounded,
    hasHoverEffect = true,
    borderRadius,
  } = props
  const aspectStyle = `aspect-[${aspect}]`
  const imgRef = useRef<HTMLImageElement>(null)
  const [imageLoaded, setImageLoaded] = useState(false)

  useEffect(() => {
    if (imgRef.current) {
      // We first define onload, before src, otherwise sometimes onload event
      // is not fired
      imgRef.current.onload = () => {
        setImageLoaded(true)
      }
      imgRef.current.src = src
    }
  }, [imgRef, src])

  return (
    <div
      className={`relative block items-center justify-center overflow-hidden ${
        rounded
          ? 'mx-auto aspect-square h-[80px] w-[80px] rounded-[50%] text-center md:h-[120px] md:w-[120px] lg:h-[180px] lg:w-[180px]'
          : `${aspectStyle} h-full w-full  ${
              borderRadius ? `rounded-[${borderRadius}]` : 'rounded-[4px]'
            } `
      }  ${className}`}
      style={{ aspectRatio: aspect }}
    >
      {/* Loading placeholder */}
      {!imageLoaded && (
        <div className='bg-gray-200 absolute inset-0 z-10 flex animate-pulse items-center justify-center rounded-[4px]'>
          <div className='border-gray-300 border-t-gray-600 h-8 w-8 animate-spin rounded-full border-4' />
        </div>
      )}

      {/* Hidden img to detect load */}
      <img
        ref={imgRef}
        src={src}
        alt=''
        onError={() => setImageLoaded(true)} // Hide spinner even on error
        className='hidden'
      />

      {/* Actual Image */}
      <Image
        className={`h-full max-h-none w-full max-w-none ${
          borderRadius ? `rounded-[${borderRadius}]` : 'rounded-[4px]'
        } object-cover delay-100 duration-300 ease-in-out ${
          hasHoverEffect ? 'hover:scale-125' : ''
        } transition-opacity duration-300 ${imageLoaded ? 'opacity-100' : 'opacity-0'}`}
        src={src}
        layout='fill'
        alt={alt}
      />
    </div>
  )
}
